import { Box, Divider, FormField, Input } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { AppEmbedData_AppType } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { useBiNext } from "./../../_shared/bi-context-provider/bi-context-provider.js";
import { ToggleButton } from "./../../ui-components/index.js";
import {
  MAX_BUTTON_TEXT_LENGTH,
  MAX_RIBBON_TEXT_LENGTH,
  verticalEmbedModals
} from "../constants.js";
import {
  SETTINGS_VERTICAL_EMBED_BUTTON_TEXT_INPUT,
  SETTINGS_VERTICAL_EMBED_BUTTON_TOGGLE,
  SETTINGS_VERTICAL_EMBED_DATETIME_TOGGLE,
  SETTINGS_VERTICAL_EMBED_DURATION_TOGGLE,
  SETTINGS_VERTICAL_EMBED_IMAGE_TOGGLE,
  SETTINGS_VERTICAL_EMBED_LOCATION_TOGGLE,
  SETTINGS_VERTICAL_EMBED_PRICE_TOGGLE,
  SETTINGS_VERTICAL_EMBED_RIBBON_TEXT_INPUT,
  SETTINGS_VERTICAL_EMBED_RIBBON_TOGGLE
} from "../data-hooks.js";
const getDefaultButtonText = (embedType, t) => {
  switch (embedType) {
    case AppEmbedData_AppType.PRODUCT:
      return t("VerticalEmbed_Products_Button");
    case AppEmbedData_AppType.EVENT:
      return t("VerticalEmbed_Events_Button");
    case AppEmbedData_AppType.BOOKING:
      return t("VerticalEmbed_Bookings_Button");
    default:
      return t("VerticalEmbed_Products_Button");
  }
};
const SettingsTab = ({ pmNodeAttrs, patchPmNodeAttrs }) => {
  const { t } = useContext(RicosContext);
  const logBi = useBiNext({
    modalId: verticalEmbedModals.settings,
    pluginId: "verticalEmbed",
    nodeId: pmNodeAttrs?.id
  });
  const isProductEmbed = pmNodeAttrs?.type === AppEmbedData_AppType.PRODUCT;
  const isEventEmbed = pmNodeAttrs?.type === AppEmbedData_AppType.EVENT;
  const isBookingEmbed = pmNodeAttrs?.type === AppEmbedData_AppType.BOOKING;
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP3", padding: "SP3", overflow: "auto" }, /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      title: t("Embed_Vertical_Settings_Show_Image"),
      checked: !pmNodeAttrs?.hideImage,
      onChange: () => {
        logBi({
          dataHook: SETTINGS_VERTICAL_EMBED_IMAGE_TOGGLE,
          value: !pmNodeAttrs?.hideImage
        });
        patchPmNodeAttrs({
          hideImage: !pmNodeAttrs?.hideImage
        });
      },
      dataHook: SETTINGS_VERTICAL_EMBED_IMAGE_TOGGLE,
      size: "small"
    }
  ), isProductEmbed && /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      title: t("Embed_Vertical_Settings_Show_Price"),
      checked: !pmNodeAttrs?.hidePrice,
      onChange: () => {
        logBi({
          dataHook: SETTINGS_VERTICAL_EMBED_PRICE_TOGGLE,
          value: !pmNodeAttrs?.hidePrice
        });
        patchPmNodeAttrs({
          hidePrice: !pmNodeAttrs?.hidePrice
        });
      },
      dataHook: SETTINGS_VERTICAL_EMBED_PRICE_TOGGLE,
      size: "small"
    }
  ), isEventEmbed && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      title: t("Embed_Vertical_Settings_Show_Price"),
      checked: !pmNodeAttrs?.hidePrice,
      onChange: () => {
        logBi({
          dataHook: SETTINGS_VERTICAL_EMBED_PRICE_TOGGLE,
          value: !pmNodeAttrs?.hidePrice
        });
        patchPmNodeAttrs({
          hidePrice: !pmNodeAttrs?.hidePrice
        });
      },
      dataHook: SETTINGS_VERTICAL_EMBED_PRICE_TOGGLE,
      size: "small"
    }
  ), /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      title: t("Embed_Vertical_Settings_Show_DateTime"),
      checked: !pmNodeAttrs?.hideDateTime,
      onChange: () => {
        logBi({
          dataHook: SETTINGS_VERTICAL_EMBED_DATETIME_TOGGLE,
          value: !pmNodeAttrs?.hideDateTime
        });
        patchPmNodeAttrs({
          hideDateTime: !pmNodeAttrs?.hideDateTime
        });
      },
      dataHook: SETTINGS_VERTICAL_EMBED_DATETIME_TOGGLE,
      size: "small"
    }
  ), /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      title: t("Embed_Vertical_Settings_Show_Location"),
      checked: !pmNodeAttrs?.hideLocation,
      onChange: () => {
        logBi({
          dataHook: SETTINGS_VERTICAL_EMBED_LOCATION_TOGGLE,
          value: !pmNodeAttrs?.hideLocation
        });
        patchPmNodeAttrs({
          hideLocation: !pmNodeAttrs?.hideLocation
        });
      },
      dataHook: SETTINGS_VERTICAL_EMBED_LOCATION_TOGGLE,
      size: "small"
    }
  )), isBookingEmbed && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      title: t("Embed_Vertical_Settings_Show_Price"),
      checked: !pmNodeAttrs?.hidePrice,
      onChange: () => {
        logBi({
          dataHook: SETTINGS_VERTICAL_EMBED_PRICE_TOGGLE,
          value: !pmNodeAttrs?.hidePrice
        });
        patchPmNodeAttrs({
          hidePrice: !pmNodeAttrs?.hidePrice
        });
      },
      dataHook: SETTINGS_VERTICAL_EMBED_PRICE_TOGGLE,
      size: "small"
    }
  ), /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      title: t("Embed_Vertical_Settings_Show_Duration"),
      checked: !pmNodeAttrs?.hideDuration,
      onChange: () => {
        logBi({
          dataHook: SETTINGS_VERTICAL_EMBED_DURATION_TOGGLE,
          value: !pmNodeAttrs?.hideDuration
        });
        patchPmNodeAttrs({
          hideDuration: !pmNodeAttrs?.hideDuration
        });
      },
      dataHook: SETTINGS_VERTICAL_EMBED_DURATION_TOGGLE,
      size: "small"
    }
  ), /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      title: t("Embed_Vertical_Settings_Show_Location"),
      checked: !pmNodeAttrs?.hideLocation,
      onChange: () => {
        logBi({
          dataHook: SETTINGS_VERTICAL_EMBED_LOCATION_TOGGLE,
          value: !pmNodeAttrs?.hideLocation
        });
        patchPmNodeAttrs({
          hideLocation: !pmNodeAttrs?.hideLocation
        });
      },
      dataHook: SETTINGS_VERTICAL_EMBED_LOCATION_TOGGLE,
      size: "small"
    }
  )), /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      title: t("Embed_Vertical_Settings_Show_Button"),
      checked: !pmNodeAttrs?.hideButton,
      onChange: () => {
        logBi({
          dataHook: SETTINGS_VERTICAL_EMBED_BUTTON_TOGGLE,
          value: !pmNodeAttrs?.hideButton
        });
        patchPmNodeAttrs({
          hideButton: !pmNodeAttrs?.hideButton
        });
      },
      dataHook: SETTINGS_VERTICAL_EMBED_BUTTON_TOGGLE,
      size: "small"
    }
  ), !pmNodeAttrs?.hideButton && /* @__PURE__ */ React.createElement(FormField, { label: t("Embed_Vertical_Settings_Button_Text") }, /* @__PURE__ */ React.createElement(
    Input,
    {
      dataHook: SETTINGS_VERTICAL_EMBED_BUTTON_TEXT_INPUT,
      type: "text",
      maxLength: MAX_BUTTON_TEXT_LENGTH,
      value: pmNodeAttrs?.buttonStyles?.buttonText ?? getDefaultButtonText(pmNodeAttrs?.type, t),
      onChange: (e) => {
        logBi({
          dataHook: SETTINGS_VERTICAL_EMBED_BUTTON_TEXT_INPUT,
          value: e.target.value
        });
        patchPmNodeAttrs({
          buttonStyles: {
            ...pmNodeAttrs?.buttonStyles,
            buttonText: e.target.value
          }
        });
      },
      onBlur: (e) => {
        if (e.target.value === "") {
          const defaultText = getDefaultButtonText(
            pmNodeAttrs?.type,
            t
          );
          patchPmNodeAttrs({
            buttonStyles: {
              ...pmNodeAttrs?.buttonStyles,
              buttonText: defaultText
            }
          });
        }
      },
      size: "small",
      textOverflow: "ellipsis"
    }
  )), /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      title: t("Embed_Vertical_Settings_Show_Ribbon"),
      checked: !(pmNodeAttrs?.hideRibbon ?? true),
      onChange: () => {
        const currentHideRibbon = pmNodeAttrs?.hideRibbon ?? true;
        const newHideRibbon = !currentHideRibbon;
        logBi({
          dataHook: SETTINGS_VERTICAL_EMBED_RIBBON_TOGGLE,
          value: !newHideRibbon
        });
        patchPmNodeAttrs({
          hideRibbon: newHideRibbon
        });
      },
      dataHook: SETTINGS_VERTICAL_EMBED_RIBBON_TOGGLE,
      size: "small"
    }
  ), !(pmNodeAttrs?.hideRibbon ?? true) && /* @__PURE__ */ React.createElement(FormField, { label: t("Embed_Vertical_Settings_Ribbon_Text") }, /* @__PURE__ */ React.createElement(
    Input,
    {
      dataHook: SETTINGS_VERTICAL_EMBED_RIBBON_TEXT_INPUT,
      type: "text",
      maxLength: MAX_RIBBON_TEXT_LENGTH,
      value: pmNodeAttrs?.ribbonStyles?.ribbonText ?? t("VerticalEmbed_Ribbon"),
      onChange: (e) => {
        logBi({
          dataHook: SETTINGS_VERTICAL_EMBED_RIBBON_TEXT_INPUT,
          value: e.target.value
        });
        patchPmNodeAttrs({
          ribbonStyles: {
            ...pmNodeAttrs?.ribbonStyles,
            ribbonText: e.target.value
          }
        });
      },
      onBlur: (e) => {
        if (e.target.value === "") {
          const defaultText = t("VerticalEmbed_Ribbon");
          patchPmNodeAttrs({
            ribbonStyles: {
              ...pmNodeAttrs?.ribbonStyles,
              ribbonText: defaultText
            }
          });
        }
      },
      size: "small",
      textOverflow: "ellipsis"
    }
  )));
};
export {
  SettingsTab
};
//# sourceMappingURL=SettingsTab.js.map
